import { FieldShell } from './FieldShell';
import type { FieldComponentProps } from './types';

export const DecimalField = ({ field, value, error, onChange }: FieldComponentProps) => {
  const c = field.constraints || {};
  return (
    <FieldShell field={field} error={error}>
      <input
        id={field.title}
        type="number"
        inputMode="decimal"
        step="any"
        className="form-input"
        min={typeof c.min_value === 'number' ? c.min_value : undefined}
        max={typeof c.max_value === 'number' ? c.max_value : undefined}
        value={value === '' || value === undefined || value === null ? '' : String(value)}
        onChange={(e) => {
          const raw = e.target.value;
          if (raw === '') {
            onChange('');
            return;
          }
          const n = Number(raw);
          onChange(Number.isNaN(n) ? raw : n);
        }}
      />
    </FieldShell>
  );
};
